exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style__Search___29cNz {\n  height: 63px;\n  width: 100%; }\n\n.style__SearchInput___3ZUEr {\n  width: 100%;\n  border: none;\n  margin-left: 16px; }\n  .style__SearchInput___3ZUEr::-webkit-input-placeholder {\n    font-size: 25px;\n    font-weight: 300; }\n  .style__SearchInput___3ZUEr::-moz-placeholder {\n    font-size: 25px;\n    font-weight: 300; }\n  .style__SearchInput___3ZUEr::-ms-input-placeholder {\n    font-size: 25px;\n    font-weight: 300; }\n  .style__SearchInput___3ZUEr::placeholder {\n    font-size: 25px;\n    font-weight: 300; }\n", ""]);

// exports
exports.locals = {
	"Search": "style__Search___29cNz",
	"SearchInput": "style__SearchInput___3ZUEr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/component/Forms/SearchInput/style.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/component/Forms/SearchInput/style.css
// module chunks = 0